/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BookedInputs */

const cs_enum_booked = /** @type {(inputs: Enum_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervováno`)
};

const en_enum_booked = /** @type {(inputs: Enum_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booked`)
};

/**
* | output |
* | --- |
* | "Booked" |
*
* @param {Enum_BookedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_booked = /** @type {((inputs?: Enum_BookedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BookedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_booked(inputs)
	return cs_enum_booked(inputs)
});